<template>
    <div class="max-w-screen">
        <md-card>
            <md-card-content class="profile-other-container">
                <div class="container-left hidden desktop:block">
                    <h1>{{ $t('registration-other.profil-title-generic') }}</h1>
                    <carousel 
                        :per-page="1" 
                        :autoplay="true" 
                        :autoplay-timeout="6000" 
                        loop
                        pagination-position="bottom-overlay" 
                        pagination-active-color="#23555C"
                    >
                        <slide v-if="profilType == 'pilot' || profilType == 'generic'">
                            <img src="/imgs/registration/other/cockpit.webp">
                            <div class="slider-comment" 
                                 v-html="$t('registration-other.slide-pilot-1')"
                            />
                        </slide>
                        <slide v-if="profilType == 'pilot' || profilType == 'generic'">
                            <img src="/imgs/registration/other/company-executives.webp">
                            <div class="slider-comment" 
                                 v-html="$t('registration-other.slide-pilot-2')"
                            />
                        </slide>
                        <slide v-if="profilType == 'pilot' || profilType == 'generic'">
                            <img src="/imgs/registration/other/reseau.webp">
                            <div class="slider-comment" 
                                 v-html="$t('registration-other.slide-pilot-3')"
                            />
                        </slide>
                        <slide v-if="profilType == 'owner' || profilType == 'generic'">
                            <img src="/imgs/registration/other/hangar.webp">
                            <div class="slider-comment" 
                                 v-html="$t('registration-other.slide-owner-1')"
                            />
                        </slide>
                        <slide v-if="profilType == 'owner' || profilType == 'generic'">
                            <img src="/imgs/registration/other/roulage.webp">
                            <div class="slider-comment" 
                                 v-html="$t('registration-other.slide-owner-2')"
                            />
                        </slide>
                        <slide v-if="profilType == 'owner' || profilType == 'generic'">
                            <img src="/imgs/registration/other/reseau.webp">
                            <div class="slider-comment" 
                                 v-html="$t('registration-other.slide-owner-3')"
                            />
                        </slide>
                        <slide v-if="profilType == 'company' || profilType == 'generic'">
                            <img src="/imgs/registration/other/flotte.webp">
                            <div class="slider-comment" 
                                 v-html="$t('registration-other.slide-company-1')"
                            />
                        </slide>
                        <slide v-if="profilType == 'company' || profilType == 'generic'">
                            <img src="/imgs/registration/other/reseau.webp">
                            <div class="slider-comment" 
                                 v-html="$t('registration-other.slide-company-2')"
                            />
                        </slide>
                        <slide v-if="profilType == 'company' || profilType == 'generic'">
                            <img src="/imgs/registration/other/equipage.webp">
                            <div class="slider-comment" 
                                 v-html="$t('registration-other.slide-company-3')"
                            />
                        </slide>
                    </carousel>
                </div>
                <div class="container-right">
                    <h1 class="desktop:hidden">
                        {{ $t('registration-other.profil-title-generic') }}
                    </h1>
                    <div class="desktop:hidden">
                        <carousel 
                            :per-page="1" 
                            :autoplay="true" 
                            :autoplay-timeout="6000" 
                            loop
                            pagination-position="bottom-overlay" 
                            pagination-active-color="#23555C"
                        >
                            <slide v-if="profilType == 'pilot' || profilType == 'generic'">
                                <img src="/imgs/registration/other/cockpit.webp">
                                <div class="slider-comment" 
                                     v-html="$t('registration-other.slide-pilot-1')"
                                />
                            </slide>
                            <slide v-if="profilType == 'pilot' || profilType == 'generic'">
                                <img src="/imgs/registration/other/company-executives.webp">
                                <div class="slider-comment" 
                                     v-html="$t('registration-other.slide-pilot-2')"
                                />
                            </slide>
                            <slide v-if="profilType == 'pilot' || profilType == 'generic'">
                                <img src="/imgs/registration/other/reseau.webp">
                                <div class="slider-comment" 
                                     v-html="$t('registration-other.slide-pilot-3')"
                                />
                            </slide>
                            <slide v-if="profilType == 'owner' || profilType == 'generic'">
                                <img src="/imgs/registration/other/hangar.webp">
                                <div class="slider-comment" 
                                     v-html="$t('registration-other.slide-owner-1')"
                                />
                            </slide>
                            <slide v-if="profilType == 'owner' || profilType == 'generic'">
                                <img src="/imgs/registration/other/roulage.webp">
                                <div class="slider-comment" 
                                     v-html="$t('registration-other.slide-owner-2')"
                                />
                            </slide>
                            <slide v-if="profilType == 'owner' || profilType == 'generic'">
                                <img src="/imgs/registration/other/reseau.webp">
                                <div class="slider-comment" 
                                     v-html="$t('registration-other.slide-owner-3')"
                                />
                            </slide>
                            <slide v-if="profilType == 'company' || profilType == 'generic'">
                                <img src="/imgs/registration/other/flotte.webp">
                                <div class="slider-comment" 
                                     v-html="$t('registration-other.slide-company-1')"
                                />
                            </slide>
                            <slide v-if="profilType == 'company' || profilType == 'generic'">
                                <img src="/imgs/registration/other/reseau.webp">
                                <div class="slider-comment" 
                                     v-html="$t('registration-other.slide-company-2')"
                                />
                            </slide>
                            <slide v-if="profilType == 'company' || profilType == 'generic'">
                                <img src="/imgs/registration/other/equipage.webp">
                                <div class="slider-comment" 
                                     v-html="$t('registration-other.slide-company-3')"
                                />
                            </slide>
                        </carousel>
                    </div>
                    <form :action="action" class="registration-form mt-4" method="POST" @submit="onSubmit($event)" ref="form">
                        <input type="hidden" name="_token" :value="csrkToken">
                        <md-card class="profil-form">
                            <md-card-header>
                                <div class="md-title md-title-dark">
                                    {{ $t('registration-other.profil-intro') }}
                                </div>
                            </md-card-header>
                            <md-card-content>
                                <div class="form-row flex" v-if="profilType == 'generic'" style="flex-direction: column">
                                    <md-field :class="{'md-invalid': !!errors['type']}">
                                        <label>{{ $t('registration-other.profil-offer-type') }}</label>
                                        <md-select v-model="selectType" name="type" :disabled="submitting ? 'disabled' : null" required @md-selected="mdSelected">
                                            <md-option value="pilot">
                                                {{ $t('registration-other.profil-offer-pilot') }}
                                            </md-option>
                                            <md-option value="owner">
                                                {{ $t('registration-other.profil-offer-plane-location') }}
                                            </md-option>
                                            <md-option value="company">
                                                {{ $t('registration-other.profil-offer-company') }}
                                            </md-option>
                                        </md-select>
                                    </md-field>
                                    <div class="form-row flex" v-if="selectType == 'pilot'">
                                        <input type="hidden" v-model="fData.type" value="pilot">
                                    </div>
                                    <div class="form-row flex" v-else-if="selectType == 'owner'">
                                        <input type="hidden" v-model="fData.type" value="owner">
                                    </div>
                                    <div class="form-row flex" v-else-if="selectType == 'company'">
                                        <input type="hidden" v-model="fData.type" value="company">
                                    </div>
                                </div>
                                <div class="form-row">
                                    <md-field :class="{'md-invalid': !!errors['lastname']}">
                                        <label>{{ $t('registration.lastname') }}</label>
                                        <md-input name="lastname" v-model="fData.lastname" :disabled="submitting ? 'disabled' : null" required autofocus />
                                        <span class="md-error">{{ errors['lastname'] ? errors['lastname'][0] : '' }}</span>
                                    </md-field>
                                </div>
                                <div class="form-row">
                                    <md-field :class="{'md-invalid': !!errors['firstname']}">
                                        <label>{{ $t('registration.firstname') }}</label>
                                        <md-input name="firstname" v-model="fData.firstname" :disabled="submitting ? 'disabled' : null" required />
                                        <span class="md-error">{{ errors['firstname'] ? errors['firstname'][0] : '' }}</span>
                                    </md-field>
                                </div>
                                <div class="form-row">
                                    <md-field :class="{'md-invalid': !!errors['entity']}">
                                        <label>{{ $t('registration-other.entity') }}</label>
                                        <md-input name="entity" v-model="fData.entity" :disabled="submitting ? 'disabled' : null" required />
                                        <span class="md-error">{{ errors['entity'] ? errors['entity'][0] : '' }}</span>
                                    </md-field>
                                </div>
                                <div class="form-row">
                                    <CountrySelector
                                        :field-class="{'md-invalid': !!errors['entity_country_id']}"
                                        :errors="errors['entity_country_id']"
                                        name="entity_country_id"
                                        :disabled="submitting ? 'disabled' : null"
                                        :model="fData.entity_country_id"
                                        required
                                        @on-change="(value) => fData.entity_country_id = value"
                                        :country-id="fData.entity_country_id"
                                    />
                                </div>
                                <div class="form-row">
                                    <md-field :class="{'md-invalid': !!errors['email']}">
                                        <label>{{ $t('registration.your-email') }}</label>
                                        <md-input type="email" name="email" v-model="fData['email']" :disabled="submitting ? 'disabled' : null" dusk="email-input" required />
                                        <span class="md-error" v-html="errors.email ? errors.email[0] : ''" />
                                    </md-field>
                                </div>
                                <div class="form-row" :class="{'mt-35': !!errors.email}">
                                    <phone-field required name="phone" v-model="fData.phone" :errors="errors['phone']" :label="$t('registration.phone')" :country-id="countryId" ref="phoneInput" :disabled="submitting ? 'disabled' : null" />
                                </div>
                                <div class="form-row">
                                    <md-field :class="{ 'md-invalid': !!errors.know }">
                                        <label>
                                            {{ $t("registration-other.find-way") }}
                                        </label>
                                        <md-select
                                            name="know"
                                            dusk="know-input"
                                            :disabled="submitting ? 'disabled' : null"
                                            v-model="fData.know"
                                            required
                                        >
                                            <md-option
                                                :value="know.id"
                                                :key="know.id"
                                                v-for="know in JSON.parse(findWay)"
                                            >
                                                {{ know.label }}
                                            </md-option>
                                        </md-select>
                                        <span class="md-error">{{
                                            errors.know ? errors.know[0] : ""
                                        }}</span>
                                    </md-field>
                                </div>
                                <div class="form-row form-row-submit">
                                    <div class="form-cgu">
                                        <md-checkbox name="cgu" id="cgu" v-model="fData['cgu']" :disabled="submitting ? 'disabled' : null" dusk="cgu-checkbox" required />
                                        <label for="cgu" v-html="$t('registration-other.accept-tos')" />
                                        <span class="cgu-error">{{ errors['cgu'] ? errors['cgu'] : '' }}</span>
                                    </div>
                                    <div class="form-submit-button">
                                        <submit-button type="submit" class="registration-standalone-button" :submitting="submitting" :label="$t('registration.validate')" @click="onSubmit()" dusk="submit-profile-button" />
                                    </div>
                                </div>
                            </md-card-content>
                        </md-card>
                    </form>
                </div>
            </md-card-content>
        </md-card>
    </div>
</template>

<script>
import PhoneField from '../widgets/PhoneFieldComponent.vue';
import { Carousel, Slide } from 'vue-carousel';
import CountrySelector from '../CountrySelector.vue';

export default {
    components: {
        PhoneField,
        Carousel,
        Slide,
        CountrySelector
    },
    props: {
        profilType: String,
        action: String,
        countryId: String,
        formData: String,
        findWay: String,
    },
    data() {
        return {
            csrkToken: Laravel.csrfToken,
            fData: {
                lastname: '',
                firstname: '',
                email: '',
                phone: '',
                entity: '',
                type: '',
                cgu: false,
                know: '',
                entity_country_id: '',
            },
            errors: {
                lastname: null,
                firstname: null,
                email: null,
                phone: null,
                entity: null,
                type: null,
                cgu: null,
                know: null,
            },
            submitting: false,
            selectType:null,
        };
    },
    watch: {
        'fData.password': function(value) {
            this.errors['password'] = null;
        },
        'fData.lastname': function(value) {
            this.errors['lastname'] = null;
        },
        'fData.firstname': function(value) {
            this.errors['firstname'] = null;
        },
        'fData.entity_type': function(value) {
            this.errors['entity_type'] = null;
        },
        'fData.password_confirmation': function(value) {
            this.errors['password_confirmation'] = null;
        },
        'fData.phone': function(value) {
            this.errors['phone'] = null;
        },
        'fData.email': function(value) {
            this.errors['email'] = null;
        },
        'fData.cgu': function(value) {
            this.errors['cgu'] = null;
        },
        'fData.know': function(value) {
            this.errors['know'] = null;
        },
    },
    mounted() {
        this.fData.entity_country_id = this.countryId;
        let formDataObj = JSON.parse(this.formData);
        for (var i of Object.keys(formDataObj)) {
            this.fData[i] = formDataObj[i];
        }
    },
    methods: {
        onSubmit(event) {
            if (!this.fData['cgu']) {
                this.errors['cgu'] = this.$t('registration.need-accept-cgu');
                return false;
            }
            this.submitting = true;
            for (var i of Object.keys(this.errors)) {
                this.errors[i] = null;
            }
            if (event) {
                event.preventDefault();
            }
            if (this.profilType) {
                this.fData.type = this.profilType;
            }
            axios.post(this.$refs.form.action, this.fData)
                .then((response) => {
                    if (response.data.status == 'ok') {
                        window.location = response.data.redirect;
                    } else {
                        this.submitting = false;
                    }
                }).catch((error) => {
                    this.submitting = false;
                    for (var i of Object.keys(this.errors)) {
                        this.errors[i] = error.response.data.errors[i];
                    }
                });
        },
        mdSelected(val){
            if (val == 'pilot' || val == 'owner' || val == 'company') {
                this.fData['type'] = val;
            } else {
                this.fData['type'] = '';
            }
        }

    }
};
</script>
<style lang="scss" scoped>
    .form-row.flex.md-invalid {
        .md-error {
            color: #ff1744;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/registration-other/ProfileComponent.vue